
<div class="overlay-mask"></div>
<div class="main-wrapper collapsed">

  <!--<app-sidebar></app-sidebar>-->

  <div class="right-area">

    <app-header></app-header>

    <div class="main-content">

      <router-outlet />

    </div>
  </div>
</div>
